import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
  commentCardContainer: {
    backgroundColor: "#FFF",
    borderRadius: 16,
    padding: 48,
    "@media (max-width: 600px)": {
      padding: 24
    }
  },
  commentCardAuthorInfo: {
    fontSize: 18,
    fontWeight: 700,
    lineHeight: 1.5,
    "@media (max-width: 600px)": {
      fontSize: 14
    }
  },
  commentText: {
    marginTop: 16,
    fontSize: 18,
    fontWeight: 500,
    lineHeight: 1.5,
    "@media (max-width: 600px)": {
      fontSize: 14
    }
  }
});
